module.exports = __webpack_public_path__ + "img/nod-pic.87e753cf.png";